import { WorkflowType } from "@/api/generated/models";
import { Skeleton, YStack } from "@/components";
import { SidebarPendingState } from "@/conversation/sidebar/SidebarPendingState";
import UserProgressionFlow from "@/conversation/sidebar/UserProgression/UserProgressionFlow";
import {
  useAIDoctorProgression,
  useInvalidateAIDoctorProgression,
} from "./useAIDoctorProgression";

const AIDoctorIntakeFlow = ({
  type,
  onClose,
  hideCloseButton,
}: {
  type: WorkflowType;
  onClose: () => void;
  hideCloseButton?: boolean;
}) => {
  const {
    data: progression,
    isPending,
    isError,
    retry,
  } = useAIDoctorProgression(type);
  const invalidate = useInvalidateAIDoctorProgression();

  const handleClose = () => {
    invalidate(type);
    onClose();
  };

  if (isPending) {
    return (
      <YStack
        flex={1}
        borderRadius="$150"
        backgroundColor="$fillModal"
        padding="$200"
        gap="$200"
      >
        <Skeleton height="$400" />
        <Skeleton height="$200" />
        <Skeleton height="$200" />
      </YStack>
    );
  }

  if (!progression) {
    if (isError) {
      return (
        <SidebarPendingState
          onClose={handleClose}
          hideCloseButton={hideCloseButton}
          message={{
            title: "Something went wrong",
            subtitle: "We couldn't load your session. Please try again.",
          }}
          ctaLabel="Try again"
          onCtaPress={retry}
          showSupportLink
        />
      );
    }
    return null;
  }

  return (
    <UserProgressionFlow
      initialProgression={progression}
      onClose={handleClose}
      hideCloseButton={hideCloseButton}
    />
  );
};

export default AIDoctorIntakeFlow;
